


export const majorTokensLookup = {
    "btc": {
        chain: "solana",
        pairAddress: "B5EwJVDuAauzUEEdwvbuXzbFFgEYnUqqS37TUM1c4PQA",
    },
    "bnb": {
        chain: "solana",
        pairAddress: "4gnf3XVk8A3vxFnnPtVqSFZa1SEPeXogvcetpZm6Q3pS",
    },
    "eth": {
        chain: "solana",
        pairAddress: "AU971DrPyhhrpRnmEBp5pDTWL2ny7nofb5vYBjDJkR2E",
    },
    "xrp": {
        chain: "bsc",
        pairAddress: "0x71f5a8F7d448E59B1ede00A19fE59e05d125E742",
    },
    "sol": {
        chain: "bsc",
        pairAddress: "0x9F5a0AD81Fe7fD5dFb84EE7A0CFb83967359BD90",
    },
    "monster": {
        chain: "ethereum",
        pairAddress: "0x4dD73c9D95fd5E8fD91D9f88dfC958d3742c7bE1",
    }
}


export const mCoinsData = {
    "btc": {
        logo: require("../media/logos/logo_chain_bitcoin.png"),
        name: "BITCOIN",
        price: 0,
        percent: 0
    },
    "eth": {
        logo: require("../media/logos/logo_chain_ethereum.png"),
        name: "ETHEREUM",
        price: 0,
        percent: 0
    },
    "monster": {
        logo: require("../media/monster_brains_mark.png"),
        name: "MONSTER",
        price: '0.000277',
        percent: 22
    },
    "xrp": {
        logo: require("../media/logos/logo_chain_xrp.png"),
        name: "XRP",
        price: 0,
        percent: 0
    },
    "sol": {
        logo: require("../media/logos/logo_chain_solana.png"),
        name: "SOLANA",
        price: 0,
        percent: 0
    },
    "bnb": {
        logo: require("../media/logos/logo_chain_bsc.png"),
        name: "BNB",
        price: 0,
        percent: 0
    }
}

